<div *ngIf="supplier" class="card mt-2">
    <div *ngIf="loading" class="d-flex justify-content-center">
        <H5 class="text-warning my-5">Chargement en cours...</H5>
    </div>
    <div *ngIf="!loading">
        <div class="card-body card-suivi-qualite">
            <div class="row">
                <div class="col-4 offset-1">
                    <table class="table-suivi-qualite">
                        <thead>
                            <tr>
                                <th></th>
                                <th class="text-center">Détail</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><label class="control-label ml-2">EVF Evaluation fournisseur</label></td>
                                <td>
                                    <div class="d-flex flex-column ml-1 moovapps-lst">
                                        <label *ngIf="getMoovAppsList('EVF').length==0" class="control-label text-info">Pas de document EVF</label>
                                        <div *ngFor="let line of getMoovAppsList('EVF')">
                                            {{line}}
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                    <td><label class="control-label ml-2">ECF Fiche d'écart fournisseur</label></td>
                                <td>
                                    <div class="d-flex flex-column ml-1 moovapps-lst">
                                        <label *ngIf="getMoovAppsList('ECF').length==0" class="control-label text-info">Pas de document ECF</label>
                                        <div *ngFor="let line of getMoovAppsList('ECF')">
                                            {{line}}
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                    <td><label class="control-label ml-2">RAI Rapport d’audit</label></td>
                                <td>
                                    <div class="d-flex flex-column ml-1 moovapps-lst">
                                        <label *ngIf="getMoovAppsList('RAI').length==0" class="control-label text-info">Pas de document RAI</label>
                                        <div *ngFor="let line of getMoovAppsList('RAI')">
                                            {{line}}
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-6 offset-1">
                    <form id="frmSuiviAchats" name="frmSuiviQualite" #frmSuiviQualite="ngForm">
                        <div class="d-flex flex-column align-items-start">
                            <label class="control-label mb-1">Flag Qualité</label>
                            <div class="d-flex justify-content-start align-items-center">
                                <div class="indicateur mr-2" [ngClass]="selectedFlag.class"></div>
                                <kendo-dropdownlist id="selectedFlag" name="selectedFlag" [data]="lstFlags" textField="text" valueField="value" style="width:110px;"
                                    [(ngModel)]="selectedFlag" [disabled]="!canUpdateFlag">
                                </kendo-dropdownlist>
                            </div>
                            <textarea class="form-control mt-2" id="QualityComments" name="QualityComments" [required]="selectedFlag.value!=0"
                                placeholder="Commentaire (obligatoire)" [(ngModel)]="supplier.QualityComments" [disabled]="!canUpdateFlag" [hidden]="selectedFlag.value==0"
                                style="width:100%;min-height:40px;" noBlankString></textarea>
                                <validation-errors [form]="frmSuiviQualite" controlName="QualityComments"></validation-errors>
                        </div>
                    </form>
                </div>
            </div>

            
            <div class="row">
                <div class="col-4">
                    <label class="control-label">Documents qualité</label>
                </div>
            </div>
            <div class="card">
                <div class="card-body">
                    <label *ngIf="noDocQual && !editMode" class="control-label text-info">Aucun document qualité n'a été déposé</label>
                    <div *ngFor="let docCom of lstDocsQual;let i=index">
                        <pilotage-doc-commercial name="lstDocsQual{{i}}" [(ngModel)]="lstDocsQual[i]" (docChanged)="onDocQualChanged($event)" [readonly]="!canAddDocQuality">
                        </pilotage-doc-commercial>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-4">
                    <label class="control-label">Commentaires qualité</label>
                </div>
            </div>
            <div class="card">
                <div class="card-body">
                    <label *ngIf="lstQualityComments.length==0 && !editMode" class="control-label text-info">Aucun commentaire n'a été saisi</label>
                    <div *ngFor="let pc of lstQualityComments" class="mb-1">
                        <commentaire-achats [commentaire]="pc" [readonly]="!canUpdateComment"
                            (addComment)="onAddComment($event)" (delComment)="onDelComment($event)">
                        </commentaire-achats>
                    </div>
                    <div *ngIf="canUpdateSuiviQualite && editMode">
                        <commentaire-achats [commentaire]="emptyComment" [readonly]="false" canAdd="canUpdateSuiviQualite"
                            (addComment)="onAddComment($event)" (delComment)="onDelComment($event)">
                        </commentaire-achats>
                    </div>
                </div>
            </div>
        </div>
        
        <div *ngIf="canUpdateSuiviQualite" class="card-footer">
            <div class="d-flex justify-content-center">
                <button *ngIf="!editMode" type="button" class="btn btn-sm btn-primary" btnDebounceClick
                    (debounceClick)="btnEditModifQualiteClick()">Modifier</button>
                <button *ngIf="editMode" type="button" class="btn btn-sm btn-warning" btnDebounceClick
                    (debounceClick)="btnAnnuleModifQualiteClick()">Annuler</button>
                <button *ngIf="editMode" type="button" class="btn btn-sm btn-success ml-2" btnDebounceClick [disabled]="btnValidModifQualiteDisabled"
                    (debounceClick)="btnValidModifQualiteClick()">Valider</button>
            </div>
        </div>
    </div>
</div>